export default "__VITE_ASSET__DCvFsWA7__"